'use strict';

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var searchForm = document.querySelector('.header_user form');
  if (searchForm) {
    setEvent();
  }

  function setEvent() {
    var btn = getEl('button');
    btn.addEventListener('click', function (event) {
      return toggleSearch(event);
    });
  }

  function toggleSearch(event) {
    var inputLength = getInputLength();
    if (inputLength <= 0) {
      event.preventDefault();
    }
    searchForm.classList.toggle('open');
  }

  function getInputLength() {
    var input = getEl('input');
    return input.value.length;
  }

  function getEl(nodeName) {
    return [].concat((0, _toConsumableArray3.default)(searchForm)).find(function (el) {
      return el.nodeName.toLowerCase() === nodeName;
    });
  }

  var MobileMenu = function () {
    function MobileMenu(node) {
      (0, _classCallCheck3.default)(this, MobileMenu);

      this.menu = node;
      this.overlay = this.getEl('overlay');
      this.drawer = this.getEl('drawer');
      this.closeBtn = this.getEl('close_btn');
      this.body = document.body;
      this.menu.addEventListener('click', this.toggleMenu.bind(this));
    }

    (0, _createClass3.default)(MobileMenu, [{
      key: 'toggleMenu',
      value: function toggleMenu(_ref) {
        var target = _ref.target;

        if (target === this.overlay || target === this.closeBtn) {
          this.closeMenu();
        }
        if (target.classList.contains('with_sub_btn')) {
          var subMenu = target.parentNode.querySelector('.sub_menu');
          this.toggleSubMenu(target, subMenu);
        }
      }
    }, {
      key: 'getEl',
      value: function getEl(nodeName) {
        return [].concat((0, _toConsumableArray3.default)(this.menu.children)).find(function (el) {
          return el.classList.contains(nodeName);
        });
      }
    }, {
      key: 'closeMenu',
      value: function closeMenu() {
        this.body.classList.remove('move_right');
        this.menu.classList.remove('show');
      }
    }, {
      key: 'openMenu',
      value: function openMenu() {
        this.body.classList.add('move_right');
        this.menu.classList.add('show');
      }
    }, {
      key: 'toggleSubMenu',
      value: function toggleSubMenu(btn, menu) {
        if (btn.classList.contains('open')) {
          btn.classList.remove('open');
          this.closeSubMenu(menu);
        } else {
          btn.classList.add('open');
          this.openSubMenu(menu);
        }
      }
    }, {
      key: 'openSubMenu',
      value: function openSubMenu(menu) {
        var height = this.getMenuHeight(menu);
        this.setHeight(height, menu);
      }
    }, {
      key: 'closeSubMenu',
      value: function closeSubMenu(menu) {
        this.setHeight(0, menu);
      }
    }, {
      key: 'getMenuHeight',
      value: function getMenuHeight(menu) {
        return [].concat((0, _toConsumableArray3.default)(menu.children)).reduce(function (acc, el) {
          return acc + el.offsetHeight + parseInt(window.getComputedStyle(el).marginBottom, 10);
        }, 0);
      }
    }, {
      key: 'setHeight',
      value: function setHeight(height, el) {
        Object.assign(el.style, { height: height + 'px' });
      }
    }]);
    return MobileMenu;
  }();

  var menuNode = document.querySelector('.header_nav_mobile');
  var mobileMenu = new MobileMenu(menuNode);
  var burger = document.querySelector('.burger');
  burger.addEventListener('click', function () {
    return mobileMenu.openMenu();
  });
})();